import { configureStore } from '@reduxjs/toolkit';
import { shallowEqual, type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import context from '@alltrails/context/slices/contextSlice';
import { mapReducer } from '@alltrails/maps/redux/reducer';
import AdvancedMapLayersRootState from './AdvancedMapLayersRootState';

export type PreloadedState = Partial<AdvancedMapLayersRootState>;

export const reducer = {
  context,
  map: mapReducer
};

export const getConfigureStoreOptions = (preloadedState?: PreloadedState) => ({
  reducer,
  preloadedState
});

export const buildStore = (preloadedState?: PreloadedState) => configureStore(getConfigureStoreOptions(preloadedState));

export type AppStore = ReturnType<typeof buildStore>;
export type AppDispatch = AppStore['dispatch'];

// these are intended to use within the package only
export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<AdvancedMapLayersRootState> = (selector: (state: AdvancedMapLayersRootState) => any) =>
  useSelector<AdvancedMapLayersRootState, any>(selector, shallowEqual);
